import { Navigate, useParams } from "react-router-dom"

import { LOGIN_ROUTE, MERCHANT_CANTEEN_WEEK_MENU_ROUTE, SIGN_IN_WITH_OTP_ROUTE } from "../../../constants/routes"
import { AuthenticationTokenType } from "../../login/loginTypes"

export function PublicCanteenMenuBridge() {
    const { deviceSecret } = useParams<{ deviceSecret: string }>()

    if (!deviceSecret) {
        return <Navigate to={LOGIN_ROUTE} replace />
    }

    const autoLoginUrl = `${SIGN_IN_WITH_OTP_ROUTE}?token=${encodeURIComponent(deviceSecret)}&type=${AuthenticationTokenType.DEVICE_SECRET}`

    return <Navigate to={autoLoginUrl} state={{ originalUrl: MERCHANT_CANTEEN_WEEK_MENU_ROUTE }} replace />
}
